import React, { Component } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { host, googleMapKey, hearFromOptions, aggregators, radiusOptions, associations, qualifications, optLanguages, keySpecialities } from '../../helpers/commons';
import Autocomplete from 'react-autocomplete';
import Layout from '../../components/layout';
import Breadcrumbs from '../../components/breadcrumbs';
import CustomHelmet from '../../components/customHelmet';
import BrokerMap from '../../components/brokerMap';
import LazyLoad from 'react-lazy-load';
import MultiSelect from '../../components/MultiSelect';

import cx from 'classnames';
import Styles from './assets/BrokerRegister.module.css';

import loaderImage from '../../assets/images/preloader.svg';

//Data for the fields


class BrokerRegister extends Component {
    cookies = new Cookies();

    state = {
        profile: null,
        editSection: null,
        formData: {
            firstName: '',
            lastName: '',
            dob: '',
            email: '',
            mobile: '',
            weekend_calls: 'no',
            broker_postcode: '',
            broker_postcode_id: '',
            broker_radius: '15',
            lat: '',
            lng: '',
            expr: '',
            specialities: [],
            languages: [],
            industry_association: [],
            industry_qualification: [],
            abn: '',
            business_name: '',
            ofc_address: '',
            suburb: '',
            state: '',
            afsl_acl: '',
            licType: 'ACL',
            aggregator: '',
            interstate: 'no',
            about: '',
            profile_summary: '',
            show_in_directory: '',
            hearFrom: '',
            hearFromOther: '',
            termsAgreed: false,
        },
        errors: {
            firstName: '',
            lastName: '',
            dob: '',
            email: '',
            mobile: '',
            weekend_calls: '',
            broker_postcode: '',
            broker_radius: '',
            about: '',
            show_in_directory: '',
            termsAgreed: '',
            general: '',
            abn: '',
        },
        postcode: {
            value: '',
            items: [],
            requestpostcode: null,
            placeholder: 'Enter your suburb or postcode',
        },
        loading: false,
        success: false,
        activeTab: 'personal',
        enableVerify: false,
        businessNameDisabled: true,
        abnLoading: false,
        abnVerified: false,
        keySpecialities: [],
    };

    // Fetch specialities on mount
    componentDidMount() {
        // axios
        //     .get(host + '/gatsby-api/specialities')
        //     .then((response) => {
        //         this.setState({
        //             keySpecialities: response.data.map((item) => ({
        //                 name: item.name,
        //                 value: item.value,
        //                 pin: false,
        //             })),
        //         });
        //     })
        //     .catch((error) => {
        //         console.error('Error fetching specialities:', error);
        //         // Fallback to static data
        //         this.setState({
        //             keySpecialities: [
        //                 { name: 'Residential', value: 'Residential', pin: false },
        //                 { name: 'Refinance', value: 'Refinance', pin: false },
        //                 { name: 'Asset Finance', value: 'Asset Finance', pin: false },
        //                 { name: 'Business Finance', value: 'Business Finance', pin: false },
        //                 { name: 'Car Finance', value: 'Car Finance', pin: false },
        //                 { name: 'Cash-flow Finance', value: 'Cash-flow Finance', pin: false },
        //                 { name: 'Commercial Loan', value: 'Commercial Loan', pin: false },
        //                 { name: 'Debt Consolidation', value: 'Debt Consolidation', pin: false },
        //                 { name: 'Bridging Loan', value: 'Bridging Loan', pin: false },
        //                 { name: 'Islamic Loan', value: 'Islamic Loan', pin: false },
        //                 { name: 'Non-conforming Loan', value: 'Non-conforming Loan', pin: false },
        //                 { name: 'Non-resident Loan', value: 'Non-resident Loan', pin: false },
        //                 { name: 'Personal Loan', value: 'Personal Loan', pin: false },
        //                 { name: 'Reverse mortgage Loan', value: 'Reverse mortgage Loan', pin: false },
        //                 { name: 'SMSF Loan', value: 'SMSF Loan', pin: false },
        //             ],
        //         });
        //     });
    }

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox' && name === 'termsAgreed') {
            this.setState((prevState) => ({
                formData: { ...prevState.formData, [name]: checked },
                errors: { ...prevState.errors, [name]: '' },
            }));
        } else {
            this.setState((prevState) => ({
                formData: { ...prevState.formData, [name]: value },
                errors: {
                    ...prevState.errors,
                    [name]: ['firstName', 'lastName', 'dob', 'email', 'mobile', 'weekend_calls', 'broker_radius', 'about', 'show_in_directory'].includes(name)
                        ? ''
                        : prevState.errors[name],
                },
            }));
            if (name === 'abn') {
                const isNumeric = /^\d{11}$/.test(value);
                this.setState((prevState) => ({
                    enableVerify: isNumeric && value !== '',
                    abnVerified: false,
                    businessNameDisabled: true,
                    errors: { ...prevState.errors, abn: '' },
                    formData: {
                        ...prevState.formData,
                        business_name: '',
                        ofc_address: '',
                    },
                }));
            }
        }
    };

    handleMultiSelectChange = (e) => {
        const { name, value, type, checked, optValue } = e.target;
        //console.log(name + " - " + value + " - " + type + " - " + checked);
        //alert(this.state.formData["languages"]);
        // if (name == "languages") {} else 
        if (name == "languages" || name == "industry_qualification" || name == "industry_association" || name == "specialities") {
            this.setState((prevState) => {
                let selectedValues = prevState.formData[name];

                if (!Array.isArray(selectedValues)) {
                    selectedValues = selectedValues ? (selectedValues != "" ? selectedValues.split(",") : []) : [];
                }

                if (checked) {
                    // Add value if checked
                    selectedValues = [...selectedValues, value];
                } else {
                    // Remove value if unchecked
                    selectedValues = selectedValues.filter(item => item !== value);
                }

                return {
                    formData: {
                        ...prevState.formData,
                        [name]: selectedValues,
                    }
                };
            });

        } else {
            this.setState({
                formData: {
                    ...this.state.formData,
                    [name]: type === "checkbox" ? checked : value
                }
            });
        }
    };

    handlePostcodeChange = (e) => {
        const value = e.target.value.trimLeft();
        this.setState((prevState) => ({
            postcode: { ...prevState.postcode, value },
        }));

        if (value.length >= 3) {
            let source = axios.CancelToken.source();
            if (this.state.postcode.requestpostcode) {
                source.cancel();
            }
            this.setState((prevState) => ({
                postcode: { ...prevState.postcode, requestpostcode: source },
            }));
            axios
                .get(`${host}/gatsby-api/suburblookup?suburblookup=${value}`, {
                    cancelToken: source.token,
                })
                .then((response) => {
                    const postcodes = response.data.postcodes || [];
                    this.setState((prevState) => ({
                        postcode: {
                            ...prevState.postcode,
                            items: postcodes,
                            requestpostcode: null,
                        },
                    }));
                })
                .catch((error) => {
                    if (!axios.isCancel(error)) {
                        console.error(error);
                    }
                });
        } else {
            this.setState((prevState) => ({
                postcode: {
                    ...prevState.postcode,
                    items: [],
                    requestpostcode: null,
                },
            }));
        }
    };

    handlePostcodeSelect = (value, item) => {
        this.setState((prevState) => ({
            postcode: {
                ...prevState.postcode,
                value: `${item.postcode}, ${item.locality}, ${item.statecode}`,
            },
            formData: {
                ...prevState.formData,
                broker_postcode: item.postcode,
                broker_postcode_id: item.id,
                suburb: item.locality,
                state: item.region1 || item.statecode,
                lat: item.latitude,
                lng: item.longitude,
            },
            errors: {
                ...prevState.errors,
                broker_postcode: '',
            },
        }));
        this.cookies.set('postcode_id', item.id, { path: '/' });
        this.cookies.set('postcode', item.postcode, { path: '/' });
        this.cookies.set('locality', item.locality, { path: '/' });
        this.cookies.set('statecode', item.statecode, { path: '/' });
        this.cookies.set('latitude', item.latitude, { path: '/' });
        this.cookies.set('longitude', item.longitude, { path: '/' });
    };

    validateABN = async () => {
        if (!this.state.enableVerify) return;
        this.setState({ abnLoading: true, abnVerified: false });
        try {
            const response = await axios.post(host + '/gatsby-api/validate-abn', {
                abn: this.state.formData.abn,
                email: this.state.formData.email,
                credentials: 'include',
            });
            const data = response.data;
            if (data.status === true && data.info && !data.info.includes('SOAP-ERROR')) {
                this.setState((prevState) => ({
                    formData: {
                        ...prevState.formData,
                        business_name: data.info,
                        ofc_address: data.address || '',
                    },
                    abnVerified: true,
                    businessNameDisabled: true,
                }));
            } else {
                this.setState((prevState) => ({
                    errors: {
                        ...prevState.errors,
                        abn: data.info || 'Invalid ABN',
                    },
                    businessNameDisabled: false,
                }));
            }
        } catch (error) {
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    abn: 'ABN validation failed. Please try again.',
                },
                businessNameDisabled: false,
            }));
        } finally {
            this.setState({ abnLoading: false });
        }
    };

    validateForm = () => {
        const newErrors = {
            firstName: '',
            lastName: '',
            email: '',
            mobile: '',
            broker_postcode: '',
            broker_radius: '',
            specialities: '',
            languages: '',
            industry_association: '',
            industry_qualification: '',
            other_industry_qualification: '',
            other_industry_association: '',
            about: '',
            show_in_directory: '',
            aggregator: '',
            termsAgreed: '',
            general: '',
            abn: '',
        };
        let isValid = true;
        const nameRegex = /^[A-Za-z.-]+$/;
        let basicInfoError = false;
        let professionalInfoError = false;
        const today = new Date();
        const dob = this.state.formData.dob ? new Date(this.state.formData.dob) : null;

        if (!this.state.formData.firstName || !nameRegex.test(this.state.formData.firstName)) {
            newErrors.firstName = 'First name should contain only alphabets, - or .';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.lastName || !nameRegex.test(this.state.formData.lastName)) {
            newErrors.lastName = 'Last name should contain only alphabets, - or .';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.formData.email)) {
            newErrors.email = 'Invalid email format.';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.mobile || !/^\d{10}$/.test(this.state.formData.mobile)) {
            newErrors.mobile = 'Mobile number must be 10 digits.';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.broker_postcode) {
            newErrors.broker_postcode = 'Please select a servicing area.';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.broker_radius) {
            newErrors.broker_radius = 'Please select a radius.';
            isValid = false;
            basicInfoError = true;
        }
        if (!this.state.formData.termsAgreed) {
            newErrors.termsAgreed = 'You must agree to the Terms & Conditions.';
            isValid = false;
        }

        if (!this.state.abnVerified) {
            newErrors.abn = 'Please enter a valid Business ABN and "Verify".'
            basicInfoError = true;
        }

        if (this.state.formData.profile_summary != "" && this.state.formData.profile_summary.length > 120) {
            newErrors.profile_summary = 'Profile summary must be 120 characters or less.';
            isValid = false;
            basicInfoError = true;
        }

        if (!this.state.formData.industry_qualification || this.state.formData.industry_qualification.length === 0) {
            newErrors.industry_qualification = 'Please select at least one industry qualification.';
            isValid = false;
            professionalInfoError = true;
        }

        const { industry_qualification, other_industry_qualification, other_industry_association, industry_association } = this.state.formData;

        if (
            industry_qualification.includes("Other") && !other_industry_qualification?.trim()
        ) {
            newErrors.other_industry_qualification = 'Please specify other industry qualification.';
            isValid = false;
            professionalInfoError = true;
        } 

        if (
            industry_association.includes("Other") && !other_industry_association?.trim()
        ) {
            newErrors.other_industry_association = 'Please specify other industry assocation.';
            isValid = false;
            professionalInfoError = true;
        } 
 

        if (!this.state.formData.languages || this.state.formData.languages.length === 0) {
            newErrors.languages = 'Please select at least one language.';
            isValid = false;
            professionalInfoError = true;
        }

        if (!this.state.formData.specialities || this.state.formData.specialities.length === 0) {
            newErrors.specialities = 'Please select at least one speciality.';
            isValid = false;
            professionalInfoError = true;
        }

        this.setState({ errors: newErrors });
        return isValid;
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        if (!this.validateForm()) return;
        this.setState({ loading: true }); 
        try {
            const response = await fetch(host + '/gatsby-api/register-broker-profile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(this.state.formData),
                credentials: 'include',
            });
            const data = await response.json();
            if (data.success) {
                // this.setState({
                //     success: true,
                //     errors: {
                //         firstName: '',
                //         lastName: '',
                //         dob: '',
                //         email: '',
                //         mobile: '',
                //         weekend_calls: '',
                //         broker_postcode: '',
                //         broker_radius: '',
                //         about: '',
                //         show_in_directory: '',
                //         termsAgreed: '',
                //         general: '',
                //         abn: '',
                //     },
                // });
                const brokerName = this.state.formData.firstName; 
                
                if(typeof window !== "undefined")
                    window.location.href = `/broker/thank-you-for-registering-a-profile?n=${brokerName}`;

                //window.location.href = '/broker/thank-you-for-registering-a-profile';
                // setTimeout(() => {
                //     window.location.href = '/broker/login';
                // }, 3000);
            } else {
                this.setState((prevState) => ({
                    errors: {
                        ...prevState.errors,
                        general: data.message || 'Registration failed. Please try again.',
                    },
                }));
            }
        } catch (error) {
            console.error('Error registering broker:', error);
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    general: 'An error occurred. Please try again.',
                },
            }));
        } finally {
            this.setState({ loading: false });
        }
    };

    setActiveTab = (tab) => {
        this.setState({ activeTab: tab });
    };

    renderTabContent = () => {
        const { activeTab, formData, errors, postcode, abnVerified, abnLoading, enableVerify, businessNameDisabled } = this.state;

        switch (activeTab) {
            case 'personal':
                return (
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="">
                                    First Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={this.handleChange}
                                    className="form-control"
                                />
                                {errors.firstName && (
                                    <p className="mt-1 text-sm error">{errors.firstName}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="">
                                    Last Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={this.handleChange}
                                    className="form-control"
                                />
                                {errors.lastName && (
                                    <p className="mt-1 text-sm error">{errors.lastName}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="">
                                    Business E-mail <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={this.handleChange}
                                    className="form-control"
                                />
                                {errors.email && (
                                    <p className="mt-1 text-sm error">{errors.email}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label className="">
                                    Mobile <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="tel"
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={this.handleChange}
                                    className="form-control"
                                    placeholder="E.g 0490000000"
                                />
                                {errors.mobile && (
                                    <p className="mt-1 text-sm error">{errors.mobile}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="">Business ABN</label>
                                <div className="input-group mb-1">
                                    <input
                                        type="text"
                                        name="abn"
                                        value={formData.abn}
                                        onChange={this.handleChange}
                                        className={cx("form-control", abnVerified ? Styles.abnVerified : '')}
                                        placeholder="Enter 11-digit ABN"
                                    />
                                    <div className="input-group-append">
                                        {!abnVerified ? (
                                            <button
                                                type="button"
                                                className={cx(!abnLoading ? Styles.verify : '', "btn btn-default")}
                                                onClick={this.validateABN}
                                                disabled={!enableVerify || abnLoading}
                                            >
                                                {abnLoading ? <img height="25" width="auto" src={loaderImage} /> : 'Verify'}
                                            </button>
                                        ) : (
                                            <span className={Styles.tickMark}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                                                </svg>
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {errors.abn && (
                                    <p className="mt-1 text-sm error">{errors.abn}</p>
                                )}
                                {abnVerified ? <div className={Styles.verifiedMsg}>ABN is valid and verified.</div> : ''}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="">Business Name</label>
                                <input
                                    type="text"
                                    name="business_name"
                                    value={formData.business_name}
                                    onChange={this.handleChange}
                                    className="form-control"
                                    readOnly={businessNameDisabled}
                                    placeholder={businessNameDisabled ? 'Verify ABN first' : 'Enter business name'}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label className="">
                                    Profile Summary
                                </label>
                                <input
                                    type="text"
                                    name="profile_summary"
                                    value={formData.profile_summary}
                                    onChange={this.handleChange}
                                    className="form-control"
                                    placeholder="A brief about your services (Maximum 120 characters)"
                                />
                                {errors.profile_summary && (
                                    <p className="mt-1 text-sm error">{errors.profile_summary}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-8">
                            <div className="form-group">
                                <label className="">
                                    Servicing Area <span className="text-red-500">*</span>
                                </label>
                                <Autocomplete
                                    inputProps={{
                                        className: 'form-control',
                                        placeholder: postcode.placeholder,
                                        id: 'listingAutoComplete',
                                    }}
                                    getItemValue={(item) => item.postcode}
                                    items={postcode.items}
                                    renderItem={(item, isHighlighted) => (
                                        <div
                                            key={item.id}
                                            style={{
                                                padding: '5px 10px',
                                                background: isHighlighted ? '#ff8a23' : '#ffffff',
                                                color: isHighlighted ? '#ffffff' : '#333',
                                            }}
                                        >
                                            {`${item.postcode}, ${item.locality}, ${item.statecode}`}
                                        </div>
                                    )}
                                    menuStyle={{
                                        borderRadius: '3px',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        border: '1px solid #ff8a23',
                                        margin: '0',
                                        fontSize: '95%',
                                        position: 'absolute',
                                        overflow: 'auto',
                                        maxHeight: '200px',
                                        minWidth: '238px',
                                        width: '100%',
                                        zIndex: 10,
                                        left: 0,
                                        top: '43px',
                                    }}
                                    wrapperStyle={{
                                        position: 'relative',
                                        cursor: 'pointer',
                                        minHeight: '47px',
                                    }}
                                    value={postcode.value}
                                    onChange={this.handlePostcodeChange}
                                    onSelect={this.handlePostcodeSelect}
                                />
                                {errors.broker_postcode && (
                                    <p className="mt-1 text-sm error">{errors.broker_postcode}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-4">
                            <div className="form-group">
                                <label className="">
                                    Radius <span className="text-red-500">*</span>
                                </label>
                                <select
                                    name="broker_radius"
                                    value={formData.broker_radius}
                                    onChange={this.handleChange}
                                    className={cx(Styles.smField, "form-control")}
                                >
                                    {radiusOptions.map((radius) => (
                                        <option key={radius} value={radius}>
                                            + {radius} km
                                        </option>
                                    ))}
                                </select>
                                {errors.broker_radius && (
                                    <p className="mt-1 text-sm error">{errors.broker_radius}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-12">
                            {formData.lat && formData.lng && (
                                <div className={cx(Styles.areaMap, "form-group")}>
                                    <LazyLoad height={320} offsetVertical={300}>
                                        <BrokerMap
                                            key={`${formData.lat}-${formData.lng}-${formData.broker_radius}`}
                                            lat={parseFloat(formData.lat)}
                                            lng={parseFloat(formData.lng)}
                                            radius={parseInt(formData.broker_radius)}
                                            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=geometry,drawing,places`}
                                            loadingElement={<div style={{ height: `100%` }} />}
                                            containerElement={<div style={{ height: `320px` }} />}
                                            mapElement={<div style={{ height: `100%` }} />}
                                        />
                                    </LazyLoad>
                                </div>
                            )}
                        </div>
                    </div>
                );
            case 'experience':
                return (
                    <div className="space-y-4">
                        <div className="form-group">
                            <label className="">Key Specialities</label>
                            <MultiSelect
                                field={{ name: 'specialities', options: keySpecialities }}
                                formData={formData}
                                onChange={this.handleMultiSelectChange}
                                onOtherChange={this.handleChange}
                                placeHolder="Search Specialities..."
                            />
                            {errors.specialities && (
                                <p className="mt-1 text-sm error">{errors.specialities}</p>
                            )}
                            {/* <div className={cx(Styles.multipleSelectOption)}>
                                {keySpecialities.map((option) => (
                                    <label key={option.value}>
                                        <input
                                            type="checkbox"
                                            name="specialities"
                                            value={option.value}
                                            checked={formData.specialities.includes(option.value)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                this.setState((prevState) => ({
                                                    formData: {
                                                        ...prevState.formData,
                                                        specialities: checked
                                                            ? [...prevState.formData.specialities, option.value]
                                                            : prevState.formData.specialities.filter((v) => v !== option.value),
                                                    },
                                                }));
                                            }}
                                            className="hidden"
                                        />
                                        <span>{option.name}</span>
                                    </label>
                                ))}
                            </div> */}
                        </div>
                        <div className="form-group">
                            <label className="">Languages</label>
                            <MultiSelect
                                field={{ name: 'languages', options: optLanguages }}
                                formData={formData}
                                onChange={this.handleMultiSelectChange}
                                onOtherChange={this.handleChange}
                                placeHolder="Start typing a language name to search..."
                            />
                            {errors.languages && (
                                <p className="mt-1 text-sm error">{errors.languages}</p>
                            )}
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="form-group">
                                <label className="">Industry Association</label>
                                <MultiSelect
                                    field={{ name: 'industry_association', options: associations }}
                                    formData={formData}
                                    onChange={this.handleMultiSelectChange}
                                    onOtherChange={this.handleChange}
                                    placeHolder="Start typing here to search..."
                                />
                                {errors.industry_association && (
                                    <p className="mt-1 text-sm error">{errors.industry_association}</p>
                                )}
                                {errors.other_industry_association && (
                                    <p className="mt-1 text-sm error">{errors.other_industry_association}</p>
                                )}
                                {/* <div className={cx(Styles.multipleSelectOption)}>
                                    {this.associations.map((option) => (
                                        <label key={option.value}>
                                            <input
                                                type="checkbox"
                                                name="industry_association"
                                                value={option.value}
                                                checked={formData.industry_association.includes(option.value)}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    this.setState((prevState) => ({
                                                        formData: {
                                                            ...prevState.formData,
                                                            industry_association: checked
                                                                ? [...prevState.formData.industry_association, option.value]
                                                                : prevState.formData.industry_association.filter((v) => v !== option.value),
                                                        },
                                                    }));
                                                }}
                                                className="hidden"
                                            />
                                            <span>{option.name}</span>
                                        </label>
                                    ))}
                                </div> */}
                            </div>
                            <div className="form-group">
                                <label className="">Industry Qualification</label>
                                <MultiSelect
                                    field={{ name: 'industry_qualification', options: qualifications }}
                                    formData={formData}
                                    onChange={this.handleMultiSelectChange}
                                    onOtherChange={this.handleChange}
                                    placeHolder="Start typing here to search..."
                                />
                                {errors.industry_qualification && (
                                    <p className="mt-1 text-sm error">{errors.industry_qualification}</p>
                                )}
                                {errors.other_industry_qualification && (
                                    <p className="mt-1 text-sm error">{errors.other_industry_qualification}</p>
                                )}
                                {/* {
                                    this.state.formData.industry_qualification?.includes("Other") && (
                                        <div className=""> 
                                            <input
                                                type="text"
                                                name="other_industry_qualification"
                                                value={formData.other_industry_qualification}
                                                onChange={this.handleChange}
                                                className="form-control"
                                                placeholder="Enter other qualification"
                                            />
                                        </div>
                                    )
                                }
                                 */}

                                {/* <div className={cx(Styles.multipleSelectOption)}>
                                    {this.qualifications.map((option) => (
                                        <label key={option.value}>
                                            <input
                                                type="checkbox"
                                                name="industry_qualification"
                                                value={option.value}
                                                checked={formData.industry_qualification.includes(option.value)}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    this.setState((prevState) => ({
                                                        formData: {
                                                            ...prevState.formData,
                                                            industry_qualification: checked
                                                                ? [...prevState.formData.industry_qualification, option.value]
                                                                : prevState.formData.industry_qualification.filter((v) => v !== option.value),
                                                        },
                                                    }));
                                                }}
                                                className="hidden"
                                            />
                                            <span>{option.name}</span>
                                        </label>
                                    ))}
                                </div> */}
                            </div>
                        </div>
                    </div>
                );
            case 'business':
                return (
                    <div className="space-y-4">
                        <div className="form-group">
                            <label className="">
                                About your Business
                            </label>
                            <textarea
                                name="about"
                                value={formData.about}
                                onChange={this.handleChange}
                                className="form-control"
                                rows="5"
                                placeholder="Describe your business (minimum 250 characters)"
                            />
                            {errors.about && (
                                <p className="mt-1 text-sm error">{errors.about}</p>
                            )}
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="">Office Address</label>
                                    <textarea
                                        name="ofc_address"
                                        value={formData.ofc_address}
                                        onChange={this.handleChange}
                                        className="form-control"
                                        placeholder="Street address"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="">Licence Type</label>
                                    <div className="flex">
                                        <select
                                            name="licType"
                                            value={formData.licType}
                                            onChange={this.handleChange}
                                            className="form-control"
                                        >
                                            <option value="">Select</option>
                                            <option value="ACL">ACL</option>
                                            <option value="CRN">CRN</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="">Licence Number</label>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="afsl_acl"
                                        value={formData.afsl_acl}
                                        onChange={this.handleChange}
                                        className="form-control"
                                        placeholder="Enter Licence No."
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="">Total Experience</label>
                                    <input
                                        type="text"
                                        name="expr"
                                        value={formData.expr}
                                        placeholder="in Years"
                                        onChange={this.handleChange}
                                        className={cx(Styles.smField, "form-control")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="">Aggregator</label>
                                    <select
                                        name="aggregator"
                                        value={formData.aggregator}
                                        onChange={this.handleChange}
                                        className={cx("form-control")}
                                    >
                                        <option value="">Select Aggregator</option>
                                        {aggregators.map((agg) => (
                                            <option key={agg.id} value={agg.id}>
                                                {agg.business_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <label className="">
                                        Are you available for calls on weekend
                                    </label>
                                    <div className="flex space-x-4">
                                        <label className="block mr-4">
                                            <input
                                                type="radio"
                                                name="weekend_calls"
                                                value="yes"
                                                checked={formData.weekend_calls === 'yes'}
                                                onChange={this.handleChange}
                                            /> Yes
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="weekend_calls"
                                                value="no"
                                                checked={formData.weekend_calls === 'no'}
                                                onChange={this.handleChange}
                                            /> No
                                        </label>
                                    </div>
                                    {errors.weekend_calls && (
                                        <p className="mt-1 text-sm error">{errors.weekend_calls}</p>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="">
                                        Are you open for interstate leads?
                                    </label>
                                    <div className="flex space-x-4">
                                        <label className="block mr-4">
                                            <input
                                                type="radio"
                                                name="interstate"
                                                value="yes"
                                                checked={formData.interstate === 'yes'}
                                                onChange={this.handleChange}
                                            /> Yes
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="interstate"
                                                value="no"
                                                checked={formData.interstate === 'no'}
                                                onChange={this.handleChange}
                                            /> No
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="">
                                        How did you hear about HFG?
                                    </label>
                                    <select
                                        name="hearFrom"
                                        value={formData.hearFrom}
                                        onChange={this.handleChange}
                                        className="form-control"
                                    >
                                        <option value="">Select an option</option>
                                        {hearFromOptions.map((option) => (
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                    {formData.hearFrom === 'Other' && (
                                        <div className="mt-2">
                                            <label className="">
                                                Please specify:
                                            </label>
                                            <input
                                                type="text"
                                                name="hearFromOther"
                                                value={formData.hearFromOther}
                                                onChange={this.handleChange}
                                                className="form-control"
                                                placeholder="Please let us know how you heard about us"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    render() {
        const { success, errors, activeTab, loading, formData } = this.state;

        return (
            <Layout>
                <CustomHelmet
                    title="Broker Registration - HFG"
                    metaDescription="Join Hash Financial Group as a mortgage broker. Register your profile to connect with clients and grow your business."
                    canonicalUrl="/broker/register"
                />
                <Breadcrumbs
                    breadcrumbs={[
                        { name: 'Broker', path: '/broker' },
                        { name: 'Register', path: '/broker/register' },
                    ]}
                />
                <div className="min-h-screen bg-gray-100">
                    <div className="container mx-auto px-4 py-8">
                        <div className="row">
                            <div className="col-md-4 mt-5">
                                <p className={Styles.profileHeader}>Create Business Profile</p>
                                <h2 className="mb-0">Your Business.</h2>
                                <h3 className={cx(Styles.orangeColor)}>Backed by Innovation.</h3>
                                <p>Join a network that supports your success with smart technology, streamlined processes, and expert guidance.</p>
                                <p className="mt-5">
                                    <strong>Already have an account?</strong>{' '}
                                    <a href="/broker/login" className={Styles.orangeColor}>
                                        Log in
                                    </a>
                                </p>
                            </div>
                            <div className="col-md-8">
                                <div className={"card"}>
                                    <div className={cx(Styles.cardHeader, "card-header pb-0")}>
                                        <div className={cx(Styles.tabButtons, 'border-b text-center')}>
                                            <button
                                                className={`${Styles.button} ${activeTab === 'personal' ? Styles.active : ''}`}
                                                onClick={() => this.setActiveTab('personal')}
                                            >
                                                Basic Info
                                            </button>
                                            <button
                                                className={`${Styles.button} ${activeTab === 'experience' ? Styles.active : ''}`}
                                                onClick={() => this.setActiveTab('experience')}
                                            >
                                                Professional Info
                                            </button>
                                            <button
                                                className={`${Styles.button} ${activeTab === 'business' ? Styles.active : ''}`}
                                                onClick={() => this.setActiveTab('business')}
                                            >
                                                Business Info
                                            </button>
                                        </div>
                                    </div>
                                    <form className={Styles.registerationForm} onSubmit={this.handleSubmit} noValidate autoComplete="off">
                                        <div className={cx(Styles.card, 'card')}>
                                            <div className="card-body">{this.renderTabContent()}</div>
                                        </div>
                                        <div className={cx(Styles.cardFooter, "card-footer text-center")}>
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading ? <img height="25" width="auto" src={loaderImage} /> : 'Register'}
                                                </button>
                                            </div>
                                            <div className="form-group">
                                                <label className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        name="termsAgreed"
                                                        checked={formData.termsAgreed}
                                                        onChange={this.handleChange}
                                                        className="mr-2"
                                                    />
                                                    <span>
                                                        I agree to the <a href="/terms" className={Styles.orangeColor}>Terms & Conditions</a> <span className="text-red-500">*</span>
                                                    </span>
                                                </label>
                                                {errors.termsAgreed && (
                                                    <p className="mt-1 text-sm error">{errors.termsAgreed}</p>
                                                )}
                                            </div>
                                            {success && (
                                                <div className="alert alert-success">
                                                    Thank you for registering with HFG! A team member will contact you soon.
                                                </div>
                                            )}
                                            {errors.general && (
                                                <div className="alert alert-danger">
                                                    {errors.general}
                                                </div>
                                            )}
                                            <p className="mt-3">
                                                <small>
                                                    By submitting this form, you agree to our Terms of Service and Privacy Policy.<br />Your information will be handled in accordance with our data protection guidelines.
                                                </small>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default BrokerRegister;